/*
 * @Version: 1.0.0
 * @Description: 全局注册组件
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-03-15 16:47:53
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-03-18 10:41:31
 * @FilePath: /dsicm-admin-web/src/components/index.js
 */
import Vue from 'vue'
import { upperFirst , camelCase } from 'lodash'
const requireComponent = require.context(
    './global',
    true,
    /Base[A-Z]\w+\.(vue)$/
)

requireComponent.keys().forEach(fileName => {
    const componentConfig = requireComponent(fileName)
    const componentName = upperFirst(
        camelCase(
            fileName.split('/').pop().replace(/\.\w+$/, '')
        )
    )
    Vue.component(
        componentName,
        componentConfig.default || componentConfig
    )
})

import ExpandSearch from './publicSearch/expandSearch.vue'

const component = {
    install:(Vue) => {
        Vue.component('ExpandSearch',ExpandSearch);
    }
}

export default component